import { faWindowRestore } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tippy from "@tippyjs/react";
import SidekickPopoutContent from "components/SidekickPopoutContent";
import React, { memo } from "react";
import { useSelector } from "react-redux";

const widgetSelector = (state) => state.widgets;

const SideKickTippy = memo(({ setActiveDrawer, activeDrawer }) => {
    const widgets = useSelector(widgetSelector);
    const widgetCount = Object.keys(widgets).reduce((acc, widgetType) => acc + Object.keys(widgets[widgetType]).length, 0);

    return (
        <Tippy
            appendTo={() => document.body}
            zIndex="1061"
            arrow={true}
            placement="right"
            interactive={true}
            maxWidth={"none"}
            theme={"aivr"}
            hideOnClick={false}
            onTrigger={() => setActiveDrawer("Restore")}
            onUntrigger={() => setActiveDrawer("")}
            content={<SidekickPopoutContent showToolTips />}>
            <div
                className={`SidebarButtonContainer ${activeDrawer === "Restore" ? "active" : ""}`}
                id="SidebarWidgetsButton"
                role="button"
                aria-label="Map and Extensions"
                style={{ position: "relative" }}>
                <FontAwesomeIcon
                    icon={faWindowRestore}
                    style={{ fontSize: 32, fontWeight: "bold", color: "#e8dfff" }}
                />
                {widgetCount > 0 && (
                    <div className="count">
                        <span>{widgetCount}</span>
                    </div>
                )}
            </div>
        </Tippy>
    );
});

export default SideKickTippy;
